import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import Pikaday from "pikaday";
var OtPikaday = /** @class */ (function (_super) {
    tslib_1.__extends(OtPikaday, _super);
    function OtPikaday() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OtPikaday.prototype.mounted = function () {
        // may 2000
        this.picker = new Pikaday({
            field: document.createElement("input"),
            bound: false,
            container: this.$el,
            firstDay: 1,
            i18n: this.getI18n(),
        });
    };
    OtPikaday.prototype.getI18n = function () {
        var months = [], weekdays = [], weekdaysShort = [];
        var monthFormat = new Intl.DateTimeFormat(this.$i18n.locale, { month: "long" });
        for (var month = 0; month < 12; month++)
            months[month] = monthFormat.format(new Date(Date.UTC(2000, month, 1, 0, 0, 0)));
        var dayFormat = new Intl.DateTimeFormat(this.$i18n.locale, { weekday: "long" });
        var dayShortFormat = new Intl.DateTimeFormat(this.$i18n.locale, { weekday: "short" });
        // October 2000 starts on a sunday (which must be first)
        for (var weekday = 0; weekday < 7; weekday++) {
            weekdays[weekday] = dayFormat.format(new Date(Date.UTC(2000, 9, weekday + 1, 0, 0, 0)));
            weekdaysShort[weekday] = dayShortFormat.format(new Date(Date.UTC(2000, 9, weekday + 1, 0, 0, 0)));
        }
        return { previousMonth: "\u00ab", nextMonth: "\u00bb", months: months, weekdays: weekdays, weekdaysShort: weekdaysShort };
    };
    OtPikaday.prototype.destroyed = function () {
        this.picker.destroy();
    };
    OtPikaday = tslib_1.__decorate([
        Component
    ], OtPikaday);
    return OtPikaday;
}(Vue));
export default OtPikaday;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/OtPikaday.vue
// module id = 223
// module chunks = 0